import React from 'react';
import { MapPin, Edit2, Trash2, Plus } from 'lucide-react';
import { Button } from '../../../../components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../../../../components/ui/dialog';
import { LocationForm } from '../LocationForm';

const EMPTY_LOCATION = { name: '', address: '', city: '', state: '', zip_code: '', delivery_instructions: '' };

export const LocationsTab = ({ clientDetail, editingLocation, setEditingLocation, onSaveLocation, onDeleteLocation }) => (
  <div className="mt-4">
    <div className="flex justify-between items-center mb-4">
      <p className="text-sm text-gray-600">{clientDetail.locations?.length || 0} location(s)</p>
      <Button variant="outline" size="sm" onClick={() => setEditingLocation({ ...EMPTY_LOCATION })}>
        <Plus className="h-4 w-4 mr-2" />
        Add Location
      </Button>
    </div>

    {clientDetail.locations?.length > 0 ? (
      <div className="space-y-3">
        {clientDetail.locations.map((loc) => (
          <div key={loc.id} className="p-4 bg-gray-50 rounded-lg">
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="font-medium">{loc.name}</p>
                  <p className="text-sm text-gray-600">{loc.address}</p>
                  <p className="text-sm text-gray-600">{loc.city}, {loc.state} {loc.zip_code}</p>
                  {loc.delivery_instructions && (
                    <p className="text-sm text-amber-600 mt-1">📝 {loc.delivery_instructions}</p>
                  )}
                </div>
              </div>
              <div className="flex gap-1">
                <Button variant="ghost" size="icon" onClick={() => setEditingLocation(loc)}>
                  <Edit2 className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  className="text-red-500 hover:text-red-700"
                  onClick={() => onDeleteLocation(loc.id)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <p className="text-gray-500 text-center py-8">No locations</p>
    )}

    {editingLocation && (
      <Dialog open={!!editingLocation} onOpenChange={() => setEditingLocation(null)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{editingLocation.id ? 'Edit Location' : 'Add Location'}</DialogTitle>
          </DialogHeader>
          <LocationForm
            location={editingLocation}
            onSave={onSaveLocation}
            onCancel={() => setEditingLocation(null)}
          />
        </DialogContent>
      </Dialog>
    )}
  </div>
);
